import React from "react";
import useAddRef, { UseAddRefOptions } from "../useAddRef";

interface FinalPageProps extends UseAddRefOptions {}

const FinalPage: React.FC<FinalPageProps> = ({ addRef }) => {
  const ref = useAddRef({ addRef });
  return (
    <div className={`eoy-page final-page`} ref={ref}>
      <h1 className="title">Your 2025 was Outstanding</h1>
      <h2 className="subtitle">Seemplicity Magic 2026 is waiting for you</h2>
    </div>
  );
};
export default FinalPage;
